import { useEffect, useState } from "react"
import { useParams } from "react-router"
import { ID } from "src/libs/interfaces/layouts"
import Feed from "src/modules/pe-basic-module/views/core/Feed"
import { actions } from "../../data/actions"
import { GET_TEST_USER_RESULTS_ACTION, REMOVE_TEST_RESULT_ACTION } from "../../data/actionTypes"
import UserResultButton from "./UserResultButton"

const UserResultsForm = (props:any) :JSX.Element => {
    const {userId} = useParams()  
    const [results, setResults] = useState<any[]>([])

    useEffect(() => {
        console.log("UserResultsForm")
        OnGetUserTestResults()
    }, [])

    const onRemove = (id:ID) => {
        actions(REMOVE_TEST_RESULT_ACTION, {
            id 
        }).then(res => { 
            OnGetUserTestResults()
        })
    }

    const OnGetUserTestResults = () => {
        actions(
            GET_TEST_USER_RESULTS_ACTION, 
            { user_id: userId, }
        ).then(res => { 
            let results = [
                ...res.map((r:any) => ({
                    ...r,
                    onRemove: ( id:ID ) => onRemove( id )
                }))
            ]
            console.log( results )
            setResults(  results  ) 
        })
    }

    return (
        <div className="container ">
            <Feed
                items={ results }
                component={ UserResultButton }
                data_type={ "" }
                containerClassName="container " 
                params={{}}
            /> 
            {/* { results.map(result => <UserResultButton test_id={result.test_id} ID={  result.ID } onRemove={onRemove} />) } */}
        </div>
    )
} 

export default UserResultsForm